import type { ReactNode } from "react";

import { cx } from "../lib/cx";

interface GlassCardProps {
  className?: string;
  children: ReactNode;
}

export function GlassCard({ className, children }: GlassCardProps) {
  return <section className={cx("glass-card", className)}>{children}</section>;
}
